import React from 'react';
import { GatsbySSR, WrapRootElementNodeArgs } from 'gatsby';
import { ThemeProvider } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import theme from '@theme';
import './styles.css';

const MainWrapper: GatsbySSR['wrapRootElement'] = ({ element }: WrapRootElementNodeArgs) => (
  <ThemeProvider theme={theme}>
    <CssBaseline>{element}</CssBaseline>
  </ThemeProvider>
);

export default MainWrapper;
